module.exports = __webpack_public_path__ + "img/radio-outline.aa226c71.svg";